import { render, staticRenderFns } from "./ExpenseLayout.vue?vue&type=template&id=26b9f396&"
import script from "./ExpenseLayout.vue?vue&type=script&lang=js&"
export * from "./ExpenseLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports